export function scopeToId(scope: Array<string | number>): string {
  return scope.join("_");
}

export function scopeToName(scope: Array<string | number>): string {
  const [first, ...rest] = scope;
  return [first, ...rest.map(s=>`[${s}]`)].join("");
}

/**
 * Turns snake_case and CamelCase strings into something more "human" by:
 * - Capitalizing the first letter
 * - Replacing underscores with spaces
 * - Adding spaces between each lowercase letter followed by an uppercase letter
*/
export function humanize(str: string) {
  return str
    .replaceAll(/^(\w)/g, (a: string) => { return a.toUpperCase() })  // Capitalize first letter
    .replaceAll("_", " ")                                             // Replace underscores with spaces
    .replaceAll(/(?<=[a-z])(?=[A-Z])/g, " ");                         // Add spaces between a lowercase letter followed by an uppercase letter
}